import { useState, useEffect } from "react";
import {
  checkPromoCode,
  buyFeatures,
} from "../../../../api/recruiterSubscriptionsApi";
import { useNavigate } from "react-router-dom";

const pricingData = [
  {
    id: "67fd106e3e19d5839510d12c",
    title: "Text Resume Writing (Entry-Level)",
    price: "1,000",
    features: ["Standard resume format for freshers", "Delivery Time: 1 Week"],
  },
  {
    id: "67fd111d3e19d5839510d12e",
    title: "Text Resume Writing (Senior-Level)",
    price: "2,000",
    features: [
      "Advanced format for experienced professionals",
      "Delivery Time: 1 Week",
    ],
  },
  // {
  //   id: "67fd11473e19d5839510d130",
  //   title: "Video Resume Making",
  //   price: "2,500",
  //   features: [
  //     "Professional quality, 1 to 90 seconds",
  //     "Delivery Time: 1 Week",
  //   ],
  // },
  {
    id: "67fd118c3e19d5839510d132",
    title: "Professional Video Resume ",
    price: "5,000",
    features: [
      "Tailored for experienced professionals, 2 mins video",
      "Delivery Time: 1 Week",
    ],
  },
  {
    id: "67fd11c13e19d5839510d134",
    title: "Cover Letter Writing",
    price: "1,000",
    features: ["Customized to fit job applications", "Delivery Time: 1 Week"],
  },
];

const InterviewCard = ({ onSelect }) => {
  return (
    <div className="border rounded-xl p-8 hover:border-primary transition-all duration-300 hover:shadow-lg min-h-[320px] flex flex-col justify-between bg-white">
      <div>
        <h3 className="text-xl font-bold mb-3">Purchase Interviews</h3>
        <div className="flex items-baseline mb-6">
          <span className="text-xl text-gray-600">₹</span>
          <span className="text-4xl font-bold text-black ml-1">150</span>
          <span className="text-gray-600 ml-2">/ interview</span>
        </div>

        <div className="flex-grow">
          <ul className="space-y-4">
            <li className="flex items-start text-gray-600">
              <svg
                className="w-5 h-5 text-primary mr-3 mt-0.5 flex-shrink-0"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
              <span className="text-base">
                Customizable number of interviews
              </span>
            </li>
            <li className="flex items-start text-gray-600">
              <svg
                className="w-5 h-5 text-primary mr-3 mt-0.5 flex-shrink-0"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
              <span className="text-base">Select from 1 to 100 interviews</span>
            </li>
          </ul>
        </div>
      </div>

      <button
        onClick={onSelect}
        className="mt-8 w-full hover:bg-primary border border-primary hover:text-white py-3.5 px-6 rounded-lg hover:bg-primary/90 transition-colors duration-300 font-semibold text-base"
      >
        Purchase Interviews
      </button>
    </div>
  );
};

const InterviewPopup = ({ onClose }) => {
  const [quantity, setQuantity] = useState(1);
  const pricePerInterview = 150;
  const basePrice = quantity * pricePerInterview;

  // Coupon logic
  const [coupon, setCoupon] = useState("");
  const [isCouponApplied, setIsCouponApplied] = useState(false);
  const [couponValue, setCouponValue] = useState(0);
  const [couponMsg, setCouponMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const discountedPrice = Math.max(basePrice - couponValue, 0);
  const taxAmount = discountedPrice * 0.18;
  const totalAmount = discountedPrice + taxAmount;

  const handleApplyCoupon = async (e) => {
    e.preventDefault();
    setLoading(true);
    setCouponMsg("");
    try {
      const resp = await checkPromoCode(coupon, basePrice);
      if (resp?.status === 200) {
        setIsCouponApplied(true);
        setCouponValue(
          resp?.body?.data?.data?.credits
            ? resp?.body?.data?.data?.credits
            : resp?.body?.data?.data?.discount,
        );
        setCouponMsg("Coupon applied!");
      } else {
        setCouponMsg(resp?.body?.message || "Invalid coupon");
      }
    } catch (err) {
      setCouponMsg("Error applying coupon");
    }
    setLoading(false);
  };

  const handleRemoveCoupon = () => {
    setIsCouponApplied(false);
    setCouponValue(0);
    setCoupon("");
    setCouponMsg("");
  };

  const handlePayment = async () => {
    const features = [{ name: "interviews", count: quantity }];
    const payment = await buyFeatures(features);

    if (payment.status === 200) {
      const href =
        payment.body.data.checkoutPageUrl ?? payment.body.data.paymentLink;
      window.open(href, "_self");
    } else {
      console.log(payment);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl p-8 max-w-md w-full mx-4">
        <div className="flex justify-between items-start mb-6">
          <h3 className="text-2xl font-bold">Purchase Interviews</h3>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        {/* Coupon section */}
        {/* <div className="mb-6">
          <form onSubmit={handleApplyCoupon} className="flex gap-2 items-center">
            <input
              type="text"
              placeholder="Enter coupon code"
              value={coupon}
              onChange={(e) => setCoupon(e.target.value)}
              disabled={isCouponApplied}
              className="border rounded px-3 py-2 flex-1"
            />
            {!isCouponApplied ? (
              <button
                type="submit"
                className="bg-primary text-white px-4 py-2 rounded"
                disabled={loading || !coupon}
              >
                {loading ? "Applying..." : "Apply"}
              </button>
            ) : (
              <button
                type="button"
                className="text-red-500 underline"
                onClick={handleRemoveCoupon}
              >
                Remove
              </button>
            )}
          </form>
          {couponMsg && (
            <div className={`mt-2 text-sm ${isCouponApplied ? "text-green-600" : "text-red-600"}`}>
              {couponMsg}
            </div>
          )}
        </div> */}

        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Number of Interviews: {quantity}
          </label>
          <div className="flex items-center gap-4 mb-2">
            <input
              type="range"
              min="1"
              max="100"
              value={quantity}
              onChange={(e) => setQuantity(parseInt(e.target.value))}
              className="w-full h-2 bg-gray-200 rounded-lg border-none cursor-pointer"
            />
          </div>
          <div className="flex justify-between text-sm text-gray-500">
            <span>1</span>
            <span>100</span>
          </div>
        </div>

        <div className="space-y-3 mb-6">
          <div className="flex justify-between">
            <span className="text-gray-600">Price per Interview</span>
            <span>₹{pricePerInterview}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-600">
              Base Price ({quantity} interviews)
            </span>
            <span>₹{basePrice.toLocaleString()}</span>
          </div>
          {isCouponApplied && (
            <div className="flex justify-between">
              <span className="text-gray-600">Coupon Discount</span>
              <span className="text-green-600">
                -₹{couponValue.toLocaleString()}
              </span>
            </div>
          )}
          <div className="flex justify-between">
            <span className="text-gray-600">GST (18%)</span>
            <span>₹{taxAmount.toLocaleString()}</span>
          </div>
          <div className="flex justify-between font-bold text-lg pt-3 border-t">
            <span>Total Amount</span>
            <span>₹{totalAmount.toLocaleString()}</span>
          </div>
        </div>

        <div className="space-y-3">
          <button
            onClick={handlePayment}
            className="w-full bg-primary text-white py-3 rounded-lg hover:bg-primary/90 transition-colors duration-300 font-semibold"
          >
            Proceed to Payment
          </button>
        </div>
      </div>
    </div>
  );
};

const PricingPlans = () => {
  const [showInterviewPopup, setShowInterviewPopup] = useState(false);
  const navigate = useNavigate();

  const handlePlanSelect = (plan) => {
    navigate("/dashboard/checkout", { state: { plan } });
  };

  useEffect(() => {
    localStorage.removeItem("subscription");
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 py-16">
      <h2 className="text-4xl font-bold text-center mb-4">Our Pricing Plans</h2>
      <p className="text-gray-600 text-center mb-12 text-lg">
        Choose the perfect plan for your career growth
      </p>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {pricingData.map((plan) => (
          <div
            key={plan.id}
            className="border rounded-xl p-8 hover:border-primary transition-all duration-300 hover:shadow-lg min-h-[320px] flex flex-col justify-between bg-white"
          >
            <div>
              <h3 className="text-xl font-bold mb-3">{plan.title}</h3>
              <div className="flex items-baseline mb-6">
                <span className="text-xl text-gray-600">₹</span>
                <span className="text-4xl font-bold text-black ml-1">
                  {plan.price}
                </span>
              </div>

              <div className="flex-grow">
                <ul className="space-y-4">
                  {plan.features.map((feature, index) => (
                    <li key={index} className="flex items-start text-gray-600">
                      <svg
                        className="w-5 h-5 text-primary mr-3 mt-0.5 flex-shrink-0"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M5 13l4 4L19 7"
                        />
                      </svg>
                      <span className="text-base">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <button
              onClick={() => handlePlanSelect(plan)}
              className="mt-8 w-full hover:bg-primary border border-primary hover:text-white py-3.5 px-6 rounded-lg hover:bg-primary/90 transition-colors duration-300 font-semibold text-base"
            >
              Choose The Plan
            </button>
          </div>
        ))}
        <InterviewCard onSelect={() => setShowInterviewPopup(true)} />
      </div>

      {showInterviewPopup && (
        <InterviewPopup onClose={() => setShowInterviewPopup(false)} />
      )}
    </div>
  );
};

export default PricingPlans;
